import { MessageErrorType } from 'src/api/membot/types';
import { MEMBOT_MAX_USER_MESSAGE_LENGTH } from 'src/apps/Conversations/constants';
import { defineMessages, IntlShape } from 'react-intl';
import emojiRegex from 'emoji-regex';

const msgs = defineMessages({
  emptyMsg: {
    id: 'communicate_error_empty_message',
    defaultMessage: 'Message is empty',
  },
  charLimit: {
    id: 'communicate_error_char_limit',
    defaultMessage: 'Character limit: {number}',
  },
});

export const getMessageError = (message: string, intl?: IntlShape) => {
  const minLength = 1;
  const maxLength = MEMBOT_MAX_USER_MESSAGE_LENGTH;
  const trimmedMessage = message.trim();
  if (trimmedMessage.length < minLength)
    return {
      text: intl?.formatMessage(msgs.emptyMsg),
      type: MessageErrorType.ltMinLength,
    };
  if (trimmedMessage.length > maxLength)
    return {
      text: intl?.formatMessage(msgs.charLimit, { number: maxLength }),
      type: MessageErrorType.gtMaxLength,
    };
};
export const initalMessage = '';

export const checkMessage = (text: string) => {
  const emojisRegex = emojiRegex();
  return text.replace(emojisRegex, '').replace(/  +/g, ' ').trimStart();
};
